import { render, staticRenderFns } from "./Discussions.vue?vue&type=template&id=a134b8e0&scoped=true"
import script from "./Discussions.vue?vue&type=script&lang=js"
export * from "./Discussions.vue?vue&type=script&lang=js"
import style0 from "./Discussions.vue?vue&type=style&index=0&id=a134b8e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a134b8e0",
  null
  
)

export default component.exports